import { render } from "./base.vue?vue&type=template&id=2a024b08&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"

import "./base.vue?vue&type=style&index=0&id=2a024b08&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a024b08"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QItem,QItemSection,QSeparator,QDialog,QCard,QCardSection,QField});
